import { devtoolsExchange } from "@urql/devtools";
import { cacheExchange } from "@urql/exchange-graphcache";
import { relayPagination } from "@urql/exchange-graphcache/extras";
import { createClient, fetchExchange } from "urql";

export const urqlClient = createClient({
  url: `${process.env.API}/graphql`,
  fetchOptions: {
    credentials: "include",
  },
  preferGetMethod: false,
  exchanges: [
    devtoolsExchange,
    cacheExchange({
      keys: {
        Dimensions: () => null,
      },
      resolvers: {
        Query: {
          blobs: relayPagination(),
        },
      },
    }),
    fetchExchange,
  ],
});
